import {
  IProductFilter,
  IStaffFilter,
  ITreatmentFilter,
  IStoreFilter,
  IOptionFilter,
  ICustomerFilter,
  ITreatmentStoreFilter,
  IProductStoreFilter,
  IOptionStoreFilter,
  IStaffStoreFilter,
  ICategoryFilter,
  IAgreementFilter,
  IHeadquarterFilter,
} from "../../models/IFilter";

export const agreementInitialFilterState: IAgreementFilter = {
  IsFilterActive: false,
  AgreementName: "",
  BusinessTypeId: -1,
  IsInvalid: false,
};

export const staffInitialFilterState: IStaffFilter = {
  IsFilterActive: false,
  StaffName: "",
  StoreId: -1,
  IsInvalid: false,
  PrefectureName: "",
  Freeword: ""
};

export const staffStoreInitialFilterState: IStaffStoreFilter = {
  IsFilterActive: false,
  StaffName: "",
  IsInvalid: false,
  Freeword: ""
};

export const storeInitialFilterState: IStoreFilter = {
  IsFilterActive: false,
  BusinessTypeId: -1,
  IsInvalid: false,
  PrefectureName: "",
  StoreName: null
};

export const headquarterInitialFilterState: IHeadquarterFilter = {
  IsFilterActive: false,
  BusinessTypeId: -1,
};

export const treatmentInitialFilterState: ITreatmentFilter = {
  IsFilterActive: false,
  TreatmentName: "",
  BusinessTypeId: -1,
  CategoryId: -1,
  IsInvalid: false,
};

export const treatmentInitialStoreFilterState: ITreatmentStoreFilter = {
  Search: "",
  IsFilterActive: false,
};
export const productInitialStoreFilterState: IProductStoreFilter = {
  Search: "",
  IsFilterActive: false,
};

export const productInitialFilterState: IProductFilter = {
  IsFilterActive: false,
  ProductName: "",
  BusinessTypeId: -1,
  CategoryId: -1,
  IsInvalid: false,
};

export const optionInitialFilterState: IOptionFilter = {
  IsFilterActive: false,
  OptionName: "",
  IsInvalid: false,
};

export const customerInitialFilterState: ICustomerFilter = {
  IsFilterActive: false,
  SearchQuery: "",
  FirstNameKana: "",
  PhoneNumber: "",
  IsBlocked: false,
  CustomerCode: ""
};

export const optionStoreInitialFilterState: IOptionStoreFilter = {
  IsFilterActive: false,
  Freeword: "",
  IsInvalid: false,
};

export const categoryInitialFilterState: ICategoryFilter = {
  IsFilterActive: false,
  Freeword: "",
  BusinessTypeId: null,
};
